import { graphql } from 'react-apollo';
import { AllCountries } from '../../queries/AllCountries';

const createOptions = (serverResponse, value1, value2) =>
  serverResponse.map((item, i) => ({
    key: i,
    value: `${item[value1]}${value2 ? item[value2] : ''}`,
    text: `${item[value1]}${value2 ? item[value2] : ''}`
  })) || [];

const withCountriesOptions = graphql(AllCountries, {
  options: () => ({ fetchPolicy: 'cache-first' }),
  props: ({ data: { allCountries, loading, error } }) => ({
    error,
    loading,
    countriesOptions: allCountries ? createOptions(allCountries, 0) : []
  })
});

export default WrappedComponent => withCountriesOptions(WrappedComponent);



// WEBPACK FOOTER //
// ./src/component/HOC/withCountriesOptions.js